import { lazy, Suspense } from "react";
import { GlobalLoading } from "../Utils";

const AdminHome = lazy(() => import("../Components/ProfilesType/Admin/AdminHome/AdminHome"));
const Approval = lazy(() => import("../Components/ProfilesType/Admin/Approval/Approval"));
const Resources = lazy(() => import("../Components/ProfilesType/Admin/Resources/Resources"));
const Subscriptions = lazy(() => import("../Components/ProfilesType/Admin/Subscriptions/Subscriptions"));
const SubscriptionPlans = lazy(() => import("../Components/ProfilesType/Admin/Subscriptions/SubscriptionPlans"));

export const adminRoutes = [
    {
        index: true,
        element: <Suspense fallback={<GlobalLoading />}><AdminHome /></Suspense>,
    },
    {
        path: "resource",
        element: <Suspense fallback={<GlobalLoading />}><Resources /></Suspense>,
    },
    {
        path: "approval",
        element: <Suspense fallback={<GlobalLoading />}><Approval /></Suspense>,
    },
    {
        path: "subscriptions",
        element: <Suspense fallback={<GlobalLoading />}><Subscriptions /></Suspense>,
        children: [
            {
                path: "plans",
                element: <Suspense fallback={<GlobalLoading />}><SubscriptionPlans /></Suspense>,
            },
        ],
    }
]
